import { runtimeConfigShared as shared } from "./runtimeConfig.shared";
export const runtimeConfig = {
    ...shared,
    runtime: "browser",
};
